/**
 * Which subscription billing screen to show (new Starter/Pro, legacy, or daily ASIN meter).
 * Shared by SubscriptionBillingSettings and order-volume UI gating.
 */

export function normalizeBillingUserType (raw) {
  return ('' + (raw === undefined || raw === null ? '' : raw)).trim().toLowerCase().replace(/\s+/g, '_')
}

/** Identity / payment-status / billingSummary user type string. */
export function billingUserTypeFromOpts (opts) {
  opts = opts || {}
  var billingSummary = opts.billingSummary
  var packageDetails = opts.packageDetails
  return (
    (billingSummary && billingSummary.userType) ||
    (billingSummary && billingSummary.user_type) ||
    opts.billingUserTypeRaw ||
    (packageDetails && packageDetails.subscriptionBillingUserType) ||
    (packageDetails && packageDetails.subscription_billing_user_type) ||
    ''
  )
}

export function isLegacyBillingUserType (opts) {
  var s = normalizeBillingUserType(billingUserTypeFromOpts(opts))
  return ['legacy', 'legacy_paid', 'legacy_free', 'legacy_paying'].indexOf(s) >= 0
}

export function isDailyBillingUserType (opts) {
  var s = normalizeBillingUserType(billingUserTypeFromOpts(opts))
  return ['daily', 'daily_usage', 'daily_meter', 'meter'].indexOf(s) >= 0
}

export function resolveBillingScreenVariant (opts) {
  opts = opts || {}
  var hasDailyPricing = !!opts.hasDailyPricing

  if (hasDailyPricing) return 'daily_usage'
  if (isLegacyBillingUserType(opts)) return 'legacy'
  if (isDailyBillingUserType(opts)) return 'daily_usage'
  
  return 'new'
}

export function isLegacyOrDailyBillingVariant (variant) {
  return variant === 'legacy' || variant === 'daily_usage'
}

/** Starter/Pro new billing — trial strip, usage tab, order meter. */
export function isNewBillingScreenVariant (opts) {
  return resolveBillingScreenVariant(opts) === 'new'
}



// WEBPACK FOOTER //
// ./src/utils/billingScreenVariant.js